import { LOCALES } from 'localization/constants/configEnums';

const getBreadCrumbItemList = (breadcrumbs, locale = LOCALES.enUS) => {
  return breadcrumbs.map((breadcrumb, i) => {
    const breadcrumbID =
      locale === LOCALES.enUS ? breadcrumb.id : `/${locale as string}${breadcrumb.id as string}`;
    return {
      '@type': 'ListItem',
      position: Number(i) + 1,
      item: {
        '@id': breadcrumbID,
        name: breadcrumb.name,
      },
    };
  });
};

export const getBreadcrumbSchema = (breadcrumbs, locale) => {
  return JSON.stringify({
    '@context': 'http://schema.org/',
    '@type': 'BreadcrumbList',
    itemListElement: getBreadCrumbItemList(
      breadcrumbs.filter((breadcrumb) => !!breadcrumb?.name),
      locale,
    ),
  });
};
